module.exports = __webpack_public_path__ + "img/cooperative0_logo21.3b010697.jpg";